<template>
  <div class="page-content PreSalesDaily">
    <h1 class="page-title">
      {{ $locale("sideMenu.reports.bookingDaily") }}
      <el-tooltip popper-class="tooltip-content" effect="dark" :content="$locale('report.bookingDaily.spec')" placement="top">
        <img src="../../assets/img/tips.png" alt="Tips" />
      </el-tooltip>
    </h1>
    <!-- <span style="white-space: pre-line; font-size: 12px; color: #aaa;">{{ $locale("report.bookingDaily.spec") }}</span> -->
    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
        <el-col :lg="14">
          <el-row :gutter="10">
            <el-col :span="16">
              <CommDatePicker
                v-model="reportDate"
                :value.sync="reportDate"
                width="100%"
                :showWeekly="true"
                :pickerOptions="datePickerOptions"
              />
            </el-col>
            <el-col :span="8">
              <el-button class="egl-btn-yellow" @click="search">{{ $locale("global.search") }}</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col class="ta-r" :lg="10">
            <el-button @click="exportCsv" class="egl-btn-yellow" :disabled="tableData.length ? false : true">{{
            $locale("global.exportToCSV")
        }}</el-button>
            <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <div id="print">
      <div class="table-module">
        <div class="info-supplement-container">
          <el-row class="module-sms" :gutter="10">
            <el-col :span="3">{{ $locale("sideMenu.reports.bookingDaily") }}</el-col>
            <el-col :span="18"
              >{{ $locale("global.cinemaName") }}：{{ cinemaName }}</el-col
            >
            <!-- <el-col :span="6">会社名：{{ brandName }}</el-col> -->
            <el-col :span="3">{{ $locale('trans.report.generatedate') }}：{{ createTime }}</el-col>

          </el-row>
          <el-row class="module-sms" :gutter="10">
              <el-col :span="6"> 年月：{{ reportDateDisplay }} </el-col>
          </el-row>
        </div>
      </div>

      <div class="custom-border-table film-table preSalesDailyDataTable">
        <el-table
          class="egl-table list-table"
          style="width: 100%"
          :data="tableData"
          :border="true"
          :span-method="objectSpanMethod"
          ref="preSalesDailyTable"
          @sort-change="sort_fn"
          @filter-change="filter"
        >
          <el-table-column
            v-for="(item, idx) in tableLabel"
            :label="item.label"
            :sortable="idx === 5 ? 'custom' : false"
            :key="idx"
            :prop="item.prop"
            :min-width="item.width"
            :align="'center'"
            :filters="item.filter && getFilterArr(item.filter)"
            :filtered-value="item.filter && getFilterValueArr(item.filter)"
            :column-key="item.columnKey && item.columnKey"
          >
              <el-table-column v-if="idx === 11" min-width="150" :label="$locale('nonArrivalTicketRecord.th.qty')" prop="ticketQty" align="center"></el-table-column>
              <el-table-column v-if="idx === 11" min-width="150" :label="$locale('global.amount')" prop="ticketAmount" align="center" :formatter="priceFormat">
              </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
    
  </div>
</template>

<style scoped>
.makeInline{
  white-space: nowrap;
}
.el-col {
  margin-bottom: 5px;
}
</style>

<script>
import "../../assets/style/preSalesDaily.less";
import CommDatePicker from "@/components/common/CommDatePicker";
import moment from "moment";
// import { priceFormat } from "../../utils/common";
import { getPreSalesDaily, } from "@/helpers/service/api/preSalesDaily";
import elTableExport from "el-table-export";

import { exportCSV_fn } from '@/assets/js/preSalesDaily_exportCSV'
import { weekLocaleArray } from "@/utils/common";

const dayList = ["日", "月", "火", "水", "木", "金", "土"];
function toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
export default {
  components: {
    CommDatePicker,
  },
  //   computed: {
  //     today() {
  //       return this.$moment().valueOf();
  //     },
  //   },
  data() {
    return {
      printObj: {
        popTitle: this.$locale("sideMenu.reports.bookingDaily"),
        id: "print"
      },
      firstGetData: true,
      today: "",
      reportDate: 0,
      reportDateDisplay: "",
      cinemaId: "",
      cinemaName: "",
      brandName: "",
      createTime: "",
      // filters_in: [],
      // filters_group: [],
      filters_column: [],
      filters_values: [],
      tableData: [],
      tableLabel: [
        {
          width: 200,
          label: this.$locale('global.titleOfWork'),
          prop: "film",
          filter: "film",
          columnKey: "film",
        },
        {
          width: 150,
          label: this.$locale('global.screenStandard'),
          prop: "version",
          filter: "version",
          columnKey: "version",
        },
        {
          width: 150,
          label: this.$locale('trans.report.version.caption'),
          prop: "subtitlesVersion",
          filter: "subtitlesVersion",
          columnKey: "subtitlesVersion",
        },
        {
          width: 180,
          label: this.$locale('global.otherVersions'),
          prop: "otherVersion",
          filter: "otherVersion",
          columnKey: "otherVersion",
        },
        {
          width: 150,
          label: this.$locale('report.preSalesDaily.showdate'),
          prop: "upcomingDate",
          filter: "upcomingDate",
          columnKey: "upcomingDate",
        },
        {
          width: 80,
          label: this.$locale('report.preSalesDaily.showtime'),
          prop: "showTime",
          sortable: true,
          // filter: "showTime",
          columnKey: "showTime",
        },
        {
          width: 80,
          label: this.$locale('global.screen'),
          prop: "house",
          filter: "house",
          columnKey: "house",
        },
        {
          width: 60,
          label: this.$locale('report.preSalesDaily.grouping'),
          prop: "baseType",
        },
        {
          width: 60,
          label: "販売",
          prop: "sale",
        },
        {
          width: 100,
          label: "券種",
          prop: "ticketType",
        },
        {
          width: 100,
          label: "料金",
          prop: "ticketPrice",
        },
        {
          width: 200,
          label: "合計（券種）",
          prop: "ticketTotal",
        },
      ],
      //for row span method, fow rowspan item, each colmun needs one set
      rowSpanArr1: [], //film
      rowSpanArr2: [], //version
      rowSpanArr3: [], //subtitlesVersion
      rowSpanArr4: [], //otherVersion
      rowSpanArr5: [], //upcomingDate
      rowSpanArr6: [], //showTime
      rowSpanArr7: [], //house
      rowSpanArr8: [], //baseType
      rowSpanArr9: [], //sale
      rowSpanPosition1: 0,
      rowSpanPosition2: 0,
      rowSpanPosition3: 0,
      rowSpanPosition4: 0,
      rowSpanPosition5: 0,
      rowSpanPosition6: 0,
      rowSpanPosition7: 0,
      rowSpanPosition8: 0,
      rowSpanPosition9: 0,
      //for filter column
      filmArr: [],
      filmIds: [],
      versionArr : [],
      versionIds : [],
      subtitlesVersionArr : [],
      subtitlesVersionIds : [],
      otherVersionArr: [],
      otherVersionIds: [],
      upcomingDateArr: [],
      upcomingDateIds : [],
      showTimeArr : [],
      showTimeIds: [],
      houseArr: [],
      houseIds : [],
      //for final row subtotal
      finalRowSubTotal : {},
      //for call report
      sort : "ASC",
      datePickerOptions: {
        disabledDate: this.dateDisableDate,
      },
    };
  },
  mounted() {
    const today = this.$moment().valueOf();

    this.reportDate = today;
    this.today = today;
    this.getDate(today);

    // this.search();
  },
  created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    //this.getList(this.filters_column, this.filters_values);
  },
  methods: {
    sort_fn() {
      //clear filter
      this.filters_column = [];
      this.filters_values = [];
      //switch sort order
      this.sort = this.sort === "ASC" ? "DESC" : "ASC";
      //call api to get data with updated sort value
      this.getList(this.filters_column, this.filters_values);
    },
    exportCsv() {
      // const that = this;
      // if (that.tableData.length > 0) {
      //   that.size = 0;
      //   that.$nextTick(function() {
      //     elTableExport(that.$refs.preSalesDailyTable, {
      //       fileName: this.$locale("sideMenu.reports.bookingDaily"),
      //       type: "csv",
      //       withBOM: false,
      //     })
      //       .then(() => {
      //         that.size = 10;
      //       })
      //       .catch(() => {
      //         that.size = 10;
      //       });
      //   });
      // }
      exportCSV_fn(this.tableData, this.today, weekLocaleArray, this.cinemaName)
    },
    getList(filters_column, filters_values, isFilter = false) {
      // console.log("getList", filters_column, filters_values, isFilter);

      this.tableData = [];
      this.rowSpanArr1 = [];
      this.rowSpanArr2 = [];
      this.rowSpanArr3 = [];
      this.rowSpanArr4 = [];
      this.rowSpanArr5 = [];
      this.rowSpanArr6 = [];
      this.rowSpanArr7 = [];
      this.rowSpanArr8 = [];
      this.rowSpanArr9 = [];
      this.finalRowSubTotal = {};
      this.reportDateDisplay = "";
      this.createTime = "";

      getPreSalesDaily({
        cinemaId: this.cinemaId,
        date: this.formatDate(this.reportDate),
        sort: this.sort,
        ...(filters_column ? { typeName: filters_column } : {}),
        ...(filters_values ? { typeNameValueList: filters_values } : {}),
      }).then(res => {

        //check if has data
        if(!res.data || !res.data.filmSales.length) { return; }

        this.finalRowSubTotal = { ...res.data.allTotal };
        this.tableData = res.data.filmSales;

        this.dataGrouping(!isFilter);
        this.rowspan(this.rowSpanArr1, this.rowSpanPosition1, "film");
        this.rowspan(this.rowSpanArr2, this.rowSpanPosition2, "version");
        this.rowspan(this.rowSpanArr3, this.rowSpanPosition3, "subtitlesVersion");
        this.rowspan(this.rowSpanArr4, this.rowSpanPosition4, "otherVersion");
        this.rowspan(this.rowSpanArr5, this.rowSpanPosition5, "upcomingDate");
        this.rowspan(this.rowSpanArr6, this.rowSpanPosition6, "showTime");
        this.rowspan(this.rowSpanArr7, this.rowSpanPosition7, "house");
        this.rowspan(this.rowSpanArr8, this.rowSpanPosition8, "baseType");
        this.rowspan(this.rowSpanArr9, this.rowSpanPosition9, "sale");

        this.cinemaName = res.data.cinema;
        this.brandName = res.data.brand;
        this.createTime = moment(new Date(res.data.exportAt)).format("YYYY-MM-DD HH:mm:ss");

        const theReportDate = this.formatDate(res.data.reportOf);
        let day = dayList[new Date(theReportDate).getDay()];
        this.reportDateDisplay = `${this.formatDate(theReportDate)}（${day}）`;

      });

    },
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD");
    },
    getDate(num) {
      this.reportDate = num;
    //   let day = dayList[new Date(num).getDay()];
    //   this.reportDateDisplay = `${this.formatDate(num)} (${day})`;
    },
    rowspan(spanArr, position, spanName) {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          spanArr.push(1);
          position = 0;
        } else if (
          this.tableData[index][spanName] ===
          this.tableData[index - 1][spanName] && this.checkIfSameGroup(this.tableData[index], this.tableData[index-1], spanName)
        ) {
          spanArr[position] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          position = index;
        }
      });
    },
    //prevent same value from different group will merge as one
    checkIfSameGroup(thisRow, lastRow, key) {
      const commonKey = ["film", "version", "subtitlesVersion", "otherVersion", "upcomingDate", "showTime" , "house", "bassType" , "sale"];
      //get current key idx
      const targetIdx = commonKey.indexOf(key);
      const lastKey = targetIdx > 0 ? commonKey[targetIdx - 1] : commonKey[targetIdx];
      //compare to last key
      if(thisRow[lastKey] === lastRow[lastKey]) {
        return true;
      }
      return false;
    },
    objectSpanMethod({ row, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.rowSpanArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.film && row.film.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 11,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.rowSpanArr2[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.version && row.version.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 10,
          };
        }
        if (row.version === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.rowSpanArr3[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.subtitlesVersion === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.rowSpanArr4[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.otherVersion === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 4) {
        const _row = this.rowSpanArr5[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.upcomingDate === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 5) {
        const _row = this.rowSpanArr6[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.showTime && row.showTime.toString().indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 6,
          };
        }
        if (row.showTime === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 6) {
        const _row = this.rowSpanArr7[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.house && row.house.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 5,
          };
        }
        if (row.house === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 7) {
        const _row = this.rowSpanArr8[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.baseType === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 8) {
        const _row = this.rowSpanArr9[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        if (row.sale && row.sale.indexOf("合計") > -1) {
          return {
            rowspan: 1,
            colspan: 7,
          };
        }
        if (row.sale === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 9) {
        if (row.ticketType === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 10) {
        if (row.ticketPrice === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 11) {
        if (row.ticketQty === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 12) {
        if (row.ticketAmount === undefined) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    dataGrouping(isNewSetData) {
      const allFilm = this.tableData;
      const finalArray = [];

      allFilm.map((film, idx) => {
        const newObj = {};
        newObj["film"] = film.film;

        //handle filter array
        // if(isNewSetData) {
        //   if(this.filmIds.indexOf(film.film) === -1) {
        //     this.filmArr.push({
        //       text: film.film,
        //       value: film.film,
        //     });
        //     this.filmIds.push(film.film);
        //   }

        // }else if(this.filmIds.indexOf(film.film)) {
        //   this.filmArr[this.filmIds.indexOf(film.film)] = ({
        //     text: film.film,
        //     value: film.film,
        //   });
        //   this.filmIds.push(film.film);
        // }
        if(this.filmIds.indexOf(film.film) === -1) {
          this.filmArr.push({
            text: film.film,
            value: film.film,
          });
          this.filmIds.push(film.film);
        }

        film.filmVersionSales.map(date => {
          newObj["version"] = date.version;
          newObj["subtitlesVersion"] = date.subtitlesVersion;
          newObj["otherVersion"] = date.otherVersion;

          //handle filter array
          if(isNewSetData && this.versionIds.indexOf(date.version) === -1) {
            this.versionArr.push({
              text: date.version,
              value: date.version
            });
            this.versionIds.push(date.version);
          }

          //handle filter array
          if(isNewSetData && this.subtitlesVersionIds.indexOf(date.subtitlesVersion) === -1) {
            this.subtitlesVersionArr.push({
              text: date.subtitlesVersion,
              value: date.subtitlesVersion
            });
            this.subtitlesVersionIds.push(date.subtitlesVersion);
          }

          //handle filter array
          if(isNewSetData && this.otherVersionIds.indexOf(date.otherVersion) === -1) {
            this.otherVersionArr.push({
              text: date.otherVersion,
              value: date.otherVersion
            });
            this.otherVersionIds.push(date.otherVersion);
          }

          date.upcomingDateSales.map((version, idx) => {
            newObj["upcomingDate"] = version.upcomingDate;

            //handle filter array
            if(isNewSetData && this.upcomingDateIds.indexOf(version.upcomingDate) === -1) {
              this.upcomingDateArr.push({
                text: version.upcomingDate,
                value: version.upcomingDate
              });
              this.upcomingDateIds.push(version.upcomingDate);
            }

            version.showtimeSales.map((showTimeSale, idx) => {
              newObj["showTime"] = moment(new Date(showTimeSale.showtime)).format("HH:mm");
              newObj["baseType"] = showTimeSale.baseType;
              newObj["house"] = showTimeSale.house;

              //handle filter array
              if(isNewSetData && this.showTimeIds.indexOf(showTimeSale.showtime) === -1) {
                this.showTimeArr.push({
                  text: showTimeSale.showtime,
                  value: showTimeSale.showtime
                });
                this.showTimeIds.push(showTimeSale.showtime);
              }

              //handle filter array
              if(isNewSetData && this.houseIds.indexOf(showTimeSale.house) === -1) {
                this.houseArr.push({
                  text: showTimeSale.house,
                  value: showTimeSale.house
                });
                this.houseIds.push(showTimeSale.house);
              }


              showTimeSale.boxOffice.map(boxOfficeSale => {
                let boxOfficeSaleObj = {
                  sale : "窓口",
                  ticketType: boxOfficeSale.name,
                  ticketAmount: boxOfficeSale.amount,
                  ticketQty: boxOfficeSale.qty,
                  ticketPrice: boxOfficeSale.price,
                };
                finalArray.push({ ...newObj, ...boxOfficeSaleObj });
              });

              showTimeSale.online.map(onlineSale => {
                let onlineSaleObj = {
                  sale : "ネット予約",
                  ticketType: onlineSale.name,
                  ticketAmount: onlineSale.amount,
                  ticketQty: onlineSale.qty,
                  ticketPrice: onlineSale.price,
                };
                finalArray.push({ ...newObj, ...onlineSaleObj });
              }); //end version.online.map

              //add sub total row
              if(idx === version.showtimeSales.length - 1) {
                //last idx, add sub total
                let lastRowSubTotal = {
                //   film: film.film,
                //   upcomingDate: version.upcomingDate,
                  house : "合計（回）",
                  baseType: undefined,
                  ticketQty: showTimeSale.showTotal.qty,
                  ticketAmount: showTimeSale.showTotal.amount,
                };
                finalArray.push({  ...newObj, ...lastRowSubTotal });
              }

            }); //end version.showtimeSales

            //add sub total row
            //last idx, add sub total
            let lastRowSubTotal = {
              //   film: film.film,
              //   upcomingDate: version.upcomingDate,
              house: undefined,
              baseType: undefined,
              showTime : "合計（日）",
              ticketQty: version.dayTotal.qty,
              ticketAmount: version.dayTotal.amount,
            };
            finalArray.push({  ...newObj, ...lastRowSubTotal });

          });//end date.upcomingDateSales


        }); //end film.upcomingDateSales.map

        //add sub total row
        let lastRowSubTotal = {
          //   film: film.film,
          //   upcomingDate: version.upcomingDate,
          film: film.film,
          version : "合計（作品）",
          ticketQty: film.filmTotal.qty,
          ticketAmount: film.filmTotal.amount,
        };
        finalArray.push({  ...lastRowSubTotal });
      }); //end allFilm.map

      //all subtotal
      let lastRowSubTotal = {
        //   film: film.film,
        //   upcomingDate: version.upcomingDate,
        film : "合計（全て）",
        ticketQty: this.finalRowSubTotal.qty,
        ticketAmount: this.finalRowSubTotal.amount,
      };
      finalArray.push({  ...lastRowSubTotal });


      //update tableData
      this.tableData = finalArray;

      //sort filter array
      this.filmArr = this.sortArray(this.filmArr);
      this.versionArr = this.sortArray(this.versionArr);
      this.subtitlesVersionArr = this.sortArray(this.subtitlesVersionArr);
      this.otherVersionArr = this.sortArray(this.otherVersionArr);
      this.upcomingDateArr = this.sortArray(this.upcomingDateArr, true);
      this.showTimeArr = this.sortArray(this.showTimeArr);
      this.houseArr = this.sortArray(this.houseArr);

      //sort id array
      this.filmIds.sort();
      this.versionIds.sort();
      this.subtitlesVersionIds.sort();
      this.otherVersionIds.sort();
      this.upcomingDateIds.sort();
      this.showTimeIds.sort();
      this.houseIds.sort();
    },
    sortArray(arr, isDate = false) {
      return arr.sort(function(a, b) {
        let keyA = isDate ? new Date(a.value) : a.value,
          keyB = isDate ?  new Date(b.value) : b.value;
        // Compare the 2 dates
        if (keyA < keyB) { return -1; }
        if (keyA > keyB) { return 1; }
        return 0;
      });
    },
    getFilterArr(type) {
      switch (type) {
      case "film":
        return this.filmArr;
      case "version":
        return this.versionArr;
      case "subtitlesVersion":
        return this.subtitlesVersionArr;
      case "otherVersion":
        return this.otherVersionArr;
      case "upcomingDate":
        return this.upcomingDateArr;
      case "showTime":
        return this.showTimeArr;
      case "house":
        return this.houseArr;
      default:
        break;
      }
    },
    getFilterValueArr(type) {
      switch (type) {
      case "film":
        return this.filmIds;
      case "version":
        return this.versionIds;
      case "subtitlesVersion":
        return this.subtitlesVersionIds;
      case "otherVersion":
        return this.otherVersionIds;
      case "upcomingDate":
        return this.upcomingDateIds;
      case "showTime":
        return this.showTimeIds;
      case "house":
        return this.houseIds;
      default:
        break;
      }
    },
    filter(value) {
      //clear filter
      this.filters_column = [];
      this.filters_values = [];

      let keys = Object.keys(value);
      let [ type ] = keys;

      this.filters_column = type;
      this.filters_values = value[type];

      this.getList(this.filters_column, this.filters_values, true);
    },
    search() {
      // console.log("search");
      this.getList(this.filters_column, this.filters_values, false);
    },
    dateDisableDate(time) {
      const _today = this.$moment().startOf("day").valueOf();
      const _curTime = this.$moment(time.getTime()).startOf("day").valueOf();
      return _curTime > _today;
    },
    priceFormat(row, column, cellValue) {
      return "¥" + toThousands(cellValue)
    }
  },
};
</script>
